/** @format */

import {CommonChartData} from '../model/charts';

const hasNegativeValue = (data: CommonChartData[]): boolean => {
  return data.some(item => {
    const values: number[] = Object.values(item)
      .filter(val => typeof val === 'number' || Array.isArray(val))
      .flat(10);
    for (let i = 0; i < values.length; i++) {
      if (values[i] < 0) {
        return true;
      }
    }
    return false;
  });
};

export {hasNegativeValue};
